import React, { ChangeEvent, useCallback } from "react";
import { RCCGrid, RCCHookToast, RCCIcon, RCCServicesApi } from "react-common-components";
import Loader from "src/components/Loader";
import PageTitle from "src/components/PageTitle";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { standardErrorMessages } from "src/utils/errors";
import FormProfile from "./FormProfile";
import { IMyProfile } from "./interface";
import DivProfilePic from "./styles";

const Profile: React.FC = () => {
	const {addToast} = RCCHookToast();
	const {translate} = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const { user, updateUserImage } = useAuth();
    
	const changeProfilePic = useCallback(async (e: ChangeEvent<HTMLInputElement>) => {
		if(!e.target.files)
			return;
			
		if(!["image/jpg", "image/jpeg", "image/png"].includes(e.target.files[0].type)){
			addToast({
				color: "red",
				title: "Erro",
				description: "Você só pode fazer uploads de arquivos jpg, jpeg ou png"
			});
			return;
		}
		
		if(e.target.files[0].size > 150000){
			addToast({
				color: "red",
				title: "Erro",
				description: "Você não pode fazer upload de imagens com tamanho maior que 150 kB"
			});
			return;
		}

			
		try{
			const formData = new FormData();
			formData.append("Files", e.target.files[0]);
			const {data} = await RCCServicesApi.postRequest({
				method: "User/ChangeProfileImage",
				body: formData,
				contentType: "multipart/form-data"
			});

			updateUserImage(data.efa005Imagem);

			addToast({
				color: "green",
				title: translate("Sucesso"),
				description: translate("Imagem do perfil atualizada com sucesso")
			});
		}catch(err){
			standardErrorMessages(err,  "Erro ao trocar imagem do perfil" , addToast);
		}
		
	}, []);

	const {data , loading, errorFetching } = useEffectFetchData<IMyProfile> (
		"User/GetInfos"
	);

	return (
		<>
			<PageTitle
				title={translate("Meu perfil")}
				icon={{
					name: "user"
				}}
			>
			</PageTitle>
			<RCCGrid container item alignItems="center" justifyContent="center" direction="column">
				<RCCGrid 
					container item
					justifyContent="center"
				>
					<DivProfilePic>
						<Photo 
							width={160}
							height={160}
							hover={false}
							name={user.efa005Nome}
							link={user.efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${user.efa005Imagem}`}
							styleInline="font-size: 2rem;"
						/>
											
						<h2>{user.efa005Tratamento} <strong>{user.efa005Nome}</strong></h2>
						<label htmlFor="profile-pic">
							<RCCIcon name="camera" />
							<input id="profile-pic" type="file" onChange={changeProfilePic}/>
						</label>
					</DivProfilePic>

                    
				</RCCGrid>
				{errorFetching ? <Title color="grey">{translate("Erro ao buscar informações do perfil, atualize a págine ou logue-se novamente")}.</Title>: <>
					{loading ? 
						<Loader /> : 
						<>
							{!data || data === null ? <Title color="grey">{translate("Erro ao buscar informações do perfil, atualize a págine ou logue-se novamente")}.</Title>: <FormProfile data={data} />}
						</>}
				</>}
                
			</RCCGrid>
		</>
	);
};

export default Profile;
